import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core";
import ShuffleIcon from '@material-ui/icons/Shuffle';
import IconButton from '@material-ui/core/IconButton';
import { randomPost } from '../../functions/post';
import Post from '../post/Post';
import logo from "../../img/logo2.png"
const useStyles = makeStyles(theme => ({
    container: {
        // position: "absolute",
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        //  overflow: "auto",
        justifyContent: 'center',
        alignItems: 'center',
        width: '1000px',
        "@media (max-width: 770px)": {
            width: "100%"
        },
    }
}));

const RandomPost = () => {
    const styles = useStyles();
    const [list, setList] = useState([]);


    useEffect(() => {
        console.log('RandomPost');
        randomPost().then(res => {
            console.log(res)
            setList([...res]);
        }).catch(err => {
            console.log(err)
        }
        )
    }, []);

    const handleShuffle = () => {
        randomPost().then(res => {
            console.log(res)
            setList([...res]);
        }).catch(err => {
            console.log(err)
        }
        )
    }

    return (
        <div >
            <div>
                <h3>
                    리서치 게시판
                    <IconButton onClick={handleShuffle}>
                        <ShuffleIcon />
                    </IconButton>
                </h3>

            </div>
            <div className={styles.container}>

                {
                    list.length > 0 ? list.map((item, index) => {
                        return (
                            <Post
                                key={index}
                                title={item.title}
                                content={item.content}
                                date={item.date}
                                deadline={item.deadline}
                                done={item.done}
                                comments={item.comments}
                                author={item.author}
                                author_info={item.author_info}
                                goal_participants={item.goal_participants}
                                participants={item.participants}
                                target={item.target}
                                with_prize={item.with_prize}
                                prize={item.prize}
                                num_prize={item.num_prize}
                                credit={item.credit}
                                num_credit={item.num_credit}
                            />

                        )
                    }
                    ) : <img src={logo} alt="logo"
                    //     style={{ width: "100%", height: "100%" }} 
                    />
                }

            </div>
        </div>
    );
};

export default RandomPost;